export type SitgLayerId =
  | 'CAD_POINT_LIMITE'
  | 'CAD_POINTFIXE_TRI'
  | 'CAD_POINTFIXE_PP'
  | 'CAD_POINTFIXE_NIV'
  | 'CAD_PARCELLE_MENSU'

export interface BBox {
  xmin: number
  ymin: number
  xmax: number
  ymax: number
}

interface GeoJSONFC {
  type: 'FeatureCollection'
  features: GeoJSON.Feature[]
}

export async function fetchSitgLayer(layer: SitgLayerId, bbox: BBox): Promise<GeoJSONFC> {
  const params = new URLSearchParams({
    where: '1=1',
    geometry: `${bbox.xmin},${bbox.ymin},${bbox.xmax},${bbox.ymax}`,
    geometryType: 'esriGeometryEnvelope',
    inSR: '4326',
    outSR: '4326',
    outFields: '*',
    returnGeometry: 'true',
    f: 'geojson',
    resultRecordCount: '2000',
  })
  const url = `/api/sitg/${layer}/FeatureServer/0/query?${params.toString()}`
  const r = await fetch(url, { credentials: 'include' })
  if (!r.ok) throw new Error(`SITG ${layer} ${r.status}`)
  const data = (await r.json()) as GeoJSONFC
  return data
}
